import React from "react";
import Select from "react-select";

import { Button } from "aible";

import styles from "./style.module.css";

import ViewContainer from "containers/View/View";
import FoldersHeaderContainer from "containers/Folders/FoldersHeader";
import DatasetLinkContainer from "containers/View/DatasetLink";
import BoomiDatasetLinkContainer from "containers/View/BoomiDatasetLink";
import DatasetSearchContainer from "containers/View/DatasetSearch";

import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { useDispatch, useSelector } from "types/store";
import {
  getFolders,
  getMoveBlueprint,
  getMoveBlueprintId,
  getMoveReport,
  getMoveReportId,
  moveBlueprintFolder,
  moveReportFolder
} from "containers/Folders/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const MoveReportModal = (props) => {
  const { moveFolderId, updateMoveFolderId, onOpenChange } = props;

  const dispatch = useDispatch();

  const folders = useSelector((state) => getFolders(state));
  const moveReportId = useSelector((state) => getMoveReportId(state));
  const moveReport = useSelector((state) => getMoveReport(state));

  return (
    <Dialog open={moveReportId !== undefined} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{moveReport?.name + " (" + moveReport?.id + ")"}</DialogTitle>
        </DialogHeader>
        <div>
          <div>{"Which folder would you like to move the assets to?"}</div>
          <Select
            options={
              folders
                ? Object.keys(folders).map((f) => ({
                    value: folders[f]?.id,
                    label: folders[f]?.name
                  }))
                : []
            }
            onChange={(val) => updateMoveFolderId(val.value)}
          />
        </div>
        <DialogFooter>
          <Button type="secondary" onClick={onOpenChange}>
            {"Cancel"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onOpenChange();
              dispatch(moveReportFolder(moveReportId, moveFolderId));
            }}
          >
            {"Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const MoveBlueprintModal = (props) => {
  const { moveFolderId, updateMoveFolderId, onOpenChange } = props;

  const dispatch = useDispatch();

  const folders = useSelector((state) => getFolders(state));
  const moveBlueprintId = useSelector((state) => getMoveBlueprintId(state));
  const moveBlueprint = useSelector((state) => getMoveBlueprint(state));

  return (
    <Dialog open={moveBlueprintId !== undefined} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{moveBlueprint?.name + " (" + moveBlueprint?.id + ")"}</DialogTitle>
        </DialogHeader>
        <div>{"Which folder would you like to move the assets to?"}</div>
        <Select
          options={
            folders
              ? Object.keys(folders).map((f) => ({
                  value: folders[f]?.id,
                  label: folders[f]?.name
                }))
              : []
          }
          onChange={(val) => updateMoveFolderId(val.value)}
        />
        <DialogFooter>
          <Button type="secondary" onClick={onOpenChange}>
            {"Cancel"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onOpenChange();
              dispatch(moveBlueprintFolder(moveBlueprintId, moveFolderId));
            }}
          >
            {"Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default class Home extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableau: -1,
      hideMenu: false,
      moveFolderId: undefined
    };
  }

  renderMoveReportModal() {
    const { moveReportId, handleMoveReport } = this.props;
    const { moveFolderId } = this.state;

    const onOpenChange = () => {
      this.setState({ moveFolderId: undefined });
      handleMoveReport(undefined);
    };

    return (
      <MoveReportModal
        onOpenChange={onOpenChange}
        moveFolderId={moveFolderId}
        updateMoveFolderId={(moveFolderId) => this.setState({ moveFolderId })}
      />
    );
  }

  renderMoveBlueprintModal() {
    const { moveBlueprintId, updateMoveBlueprintId } = this.props;
    const { moveBlueprintFolderId } = this.state;

    const onOpenChange = () => {
      this.setState({ moveBlueprintFolderId: undefined });
      updateMoveBlueprintId(undefined);
    };

    return (
      <MoveBlueprintModal
        onOpenChange={onOpenChange}
        moveFolderId={moveBlueprintFolderId}
        updateMoveFolderId={(moveBlueprintFolderId) => this.setState({ moveBlueprintFolderId })}
      />
    );
  }

  renderLinkModal() {
    return <DatasetLinkContainer />;
  }

  render() {
    const { type, search, headerMode } = this.props;
    const { hideMenu } = this.state;

    const isEDG = getIsEDG();

    return (
      <React.Fragment>
        <FoldersHeaderContainer />
        {this.renderMoveReportModal()}
        {this.renderMoveBlueprintModal()}
        {this.renderLinkModal()}
        <BoomiDatasetLinkContainer />
        {isEDG && type === "datasets" && search !== undefined && search.length > 0 ? (
          <DatasetSearchContainer />
        ) : (
          <div className={styles.home} style={{ background: isEDG ? "#FFFFFF" : undefined }}>
            <div
              style={{
                height: "calc(100vh - " + (headerMode === "OVERVIEW" ? 60 : 120) + "px)"
              }}
            >
              <ViewContainer hideMenu={hideMenu} />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
